//KAIRI
function KAIRI() {
};

KAIRI.analysis = function(technical, data) {
	// console.log("===============KAIRI.analysis start ==================");
	var param = technical.params[0];

	technical.data = {};
	
	var result = new Array();

	technical.data["result"] = result;

	KAIRI.calc(data, param, result);
};

KAIRI.calc = function(data, param, result) {
	for (var i = 0; i < data.length; i++) {
		var ma = KAIRI.calcMA(data, i, param);
		if (data[i].close != null && ma != null && ma != 0) {
			result[i] = KAIRI.round((data[i].close - ma) / ma * 100);
		}
	}
};

KAIRI.calcMA = function(data, position, param) {
	if (data[position].close == null) return null;
	if (position < param - 1) return null;

	var total = 0;
	var n = 0;

	for (var i = 0; i < param; i++) {
		if (data[position - i].close != null) {
			total += data[position - i].close;
			n++;
		}
	}

	if (n > 0) {
		return total / param;
	} else {
		return null;
	}
	
};

KAIRI.round = function(v) {
	if (v != null) {
		return Math.round(v * 10000) / 10000;
	} else {
		return null;
	}
}; 

window.KAIRI = KAIRI